import React, { useState, useEffect } from 'react';
import API from '../api'; // Configura l'oggetto Axios
import { Link } from 'react-router-dom';
import Slider from 'react-slick'; // Usa react-slick per lo slider
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ProductCard from './ProductCard';
import { ProductSkeleton } from './skeleton';
import { useGlobalShippingRates } from '../hooks/useGlobalShippingRates';

// Frecce custom SVG
const NextArrow = (props) => (
  <button {...props} className="product-slider-arrow next" aria-label="Avanti">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 4l8 8-8 8" stroke="#c93249" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  </button>
);
const PrevArrow = (props) => (
  <button {...props} className="product-slider-arrow prev" aria-label="Indietro">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 4l-8 8 8 8" stroke="#c93249" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  </button>
);

const ProductSlider = ({ 
  categoryHandle, 
  productType, 
  excludeId, 
  size = 10 
}) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Global shipping rates hook
  const { getShippingRate, loadShippingRates, loading: shippingLoading } = useGlobalShippingRates();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        let response;
        
        if (categoryHandle) {
          // Fetch per categoria
          response = await API.get(`/categories/${categoryHandle}`);
          setProducts(response.data.products || []);
        } else if (productType) {
          // Fetch per product type
          response = await API.get(`/products/by-type`, {
            params: {
              product_type: productType,
              size: size,
              exclude_id: excludeId
            }
          });
          setProducts(response.data.products || []);
        }
      } catch (error) {
        setError('Errore durante il recupero dei prodotti');
        console.error('Errore:', error);
      } finally {
        setLoading(false);
      }
    };

    if (categoryHandle || productType) {
      fetchProducts();
    }
  }, [categoryHandle, productType, excludeId, size]);

  // Load shipping rates when products change
  useEffect(() => {
    if (products.length > 0) {
      const variantIds = products.map(product => {
        // Se il prodotto ha varianti, usa la prima, altrimenti usa il product ID
        return product.variants && product.variants.length > 0 
          ? (typeof product.variants[0] === 'string' ? product.variants[0] : product.variants[0].id)
          : null;
      }).filter(id => id); // Filtra i null
      loadShippingRates(variantIds);
    }
  }, [products, loadShippingRates]);

  const calculateDiscount = (comparePrice, currentPrice) => {
    return Math.round(((comparePrice - currentPrice) / comparePrice) * 100);
  };

  // Configurazione dello slider
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  if (loading) {
    return <ProductSkeleton view="slider" count={5} />;
  }

  if (error) {
    return (
      <div className="product-slider-container">
        <div className="product-slider-error">
          <div className="product-slider-error-message">{error}</div>
        </div>
      </div>
    );
  }

  if (products.length === 0) {
    return null;
  }

  return (
    <div className="product-slider-container">
      <div className="product-slider-wrapper">
        <Slider {...sliderSettings}>
          {products.map((product) => (
            <div key={product.id} className="product-slider-card">
              <ProductCard 
                product={product} 
                shippingRate={getShippingRate(product.variants && product.variants.length > 0 ? (typeof product.variants[0] === 'string' ? product.variants[0] : product.variants[0].id) : undefined)}
                shippingLoading={shippingLoading}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ProductSlider;
